<template>
  <div class="betContent">
    <template v-if="!closeBetContent">
      <span>[{{ row["competition"] }}]</span><br />
      <span><i class="tg-icon tg-icon-grayball"></i>{{ row["team1"] }}</span
      ><br />
      <span><i class="tg-icon tg-icon-grayball"></i>{{ row["team2"] }}</span
      ><br />
    </template>
    <template v-if="!closeOdd">
      <template v-if="showBr">
        <el-row type="flex" justify="center" align="middle">
          <i class="tg-icon tg-icon-game" v-if="!closeOddIcon"></i>
          <span class="text-green">
            {{ $t(`enum.marketType[${row["marketType"]}]`) }}
            {{ $t(`enum.selectionId[${row["selectionId"]}]`) }}
          </span>
        </el-row>
        <div>
          <span>@</span>
          <span class="text-red">{{ profit }}</span>
        </div>
      </template>
      <template v-else>
        <el-row type="flex" justify="center" align="middle">
          <i class="tg-icon tg-icon-game" v-if="!closeOddIcon"></i>
          <span class="text-green">
            {{ $t(`enum.marketType[${row["marketType"]}]`) }}
            {{ $t(`enum.selectionId[${row["selectionId"]}]`) }}
          </span>
          <span>@</span>
          <span class="text-red">{{ profit }}</span>
        </el-row>
      </template>
    </template>
  </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
  props: {
    row: Object,
    closeBetContent: Boolean,
    closeOddIcon: Boolean,
    closeOdd: Boolean,
  },
  computed: {
    profit() {
      return formatter.format(this.row["profit"], "percent");
    },
    showBr() {
      return this.row["selection"] && this.row["selection"].length > 6;
    },
  },
};
</script>
